import * as React from 'react';
import {Box, Divider, Skeleton, Typography} from '@mui/material';
import {BarChart} from '@mui/x-charts/BarChart';
import {useTranslation} from 'react-i18next';
import type {CostHistoryPoint} from '../../hooks/useDashboard';

interface PayrollCostChartProps {
    readonly data: CostHistoryPoint[];
    readonly loading: boolean;
}

export default function PayrollCostChart({data, loading}: Readonly<PayrollCostChartProps>): React.ReactElement {
    const {t} = useTranslation();

    return (
        <>
            <Typography gutterBottom sx={{color: 'text.primary', fontSize: 18, fontWeight: 600, textAlign: 'left'}}>
                {t('dashboard.costChart.title')}
            </Typography>
            <Divider/>
            <br/>
            {loading && <Skeleton variant="rectangular" height={290}/>}
            {!loading && data.length === 0 && (
                <Box sx={{py: 6, textAlign: 'center'}}>
                    <Typography variant="body2" sx={{color: 'text.secondary'}}>
                        {t('dashboard.costChart.empty')}
                    </Typography>
                </Box>
            )}
            {!loading && data.length > 0 && (
                <BarChart
                    series={[
                        {data: data.map((d) => d.gross), label: t('dashboard.costChart.series.gross')},
                        {data: data.map((d) => d.cost), label: t('dashboard.costChart.series.totalCost')},
                    ]}
                    height={290}
                    xAxis={[{data: data.map((d) => d.label), scaleType: 'band'}]}
                    margin={{top: 10, bottom: 30, left: 60, right: 10}}
                    slotProps={{legend: {hidden: true}}}
                    tooltip={{trigger: 'axis'}}
                />
            )}
        </>
    );
}
